import MuiLink from '@mui/material/Link';
import type { LinkProps } from './ILink';
import { styles } from './styles';

const Link = ({ sx, ...rest }: LinkProps) => (
    <MuiLink
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Link;
